import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { profileAvatar } from "../component/ImageList";
import baseURL from "../component/baseURL";
import stringsoflanguages from '../component/stringsoflanguages';
import { Link, useNavigate, useLocation } from "react-router-dom";
import showNotification from '../component/Notification';
import PremiumSidebar from "./PremiumSidebar";

const MOBILE_PAGE_TITLE = "Info Requests";

const INFO_REQUESTS_GRID_SCROLL_KEY = 'yesmls_infoRequests_gridScrollTop';
const INFO_REQUESTS_RESTORE_SCROLL_PENDING_KEY = 'yesmls_infoRequests_restoreScrollPending';

function readInfoRequestsRestorePending() {
    try {
        return typeof sessionStorage !== 'undefined' && sessionStorage.getItem(INFO_REQUESTS_RESTORE_SCROLL_PENDING_KEY) === '1';
    } catch {
        return false;
    }
}

export default function InfoRequests() {
    const navigate = useNavigate();
    const location = useLocation();
    const isEmbeddedInPremiumHome = location.pathname.toLowerCase().includes("/premium-home");
    const [allConnections, setAllConnections] = useState([]);
    const [filteredConnections, setFilteredConnections] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [loadData, setLoadData] = useState(false);
    const [userID, setUserID] = useState(null);
    const [deleteConfirmData, setDeleteConfirmData] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState("0");
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isMobilePageOpen, setIsMobilePageOpen] = useState(false);
    const gearMenuRef = useRef(null);
    const listScrollRef = useRef(null);
    const [gridHiddenForScrollRestore, setGridHiddenForScrollRestore] = useState(() => readInfoRequestsRestorePending());
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        setUserID(userid);
        fetchDetailsAPI(userid);
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 767);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        if (!isEmbeddedInPremiumHome && window.innerWidth <= 767) {
            setIsMobilePageOpen(true);
        }
    }, [isEmbeddedInPremiumHome]);

    useEffect(() => {
        if (isEmbeddedInPremiumHome) return;
        document.body.classList.add("premium-page");
        return () => {
            document.body.classList.remove("premium-page");
        };
    }, [isEmbeddedInPremiumHome]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (gearMenuRef.current && !gearMenuRef.current.contains(e.target)) {
                setGearMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    function persistInfoRequestsGridScrollForLeave() {
        const el = listScrollRef.current;
        if (el) {
            sessionStorage.setItem(INFO_REQUESTS_GRID_SCROLL_KEY, String(el.scrollTop));
        }
        sessionStorage.setItem(INFO_REQUESTS_RESTORE_SCROLL_PENDING_KEY, '1');
    }

    useEffect(() => {
        if (loading) return undefined;
        const el = listScrollRef.current;
        if (!el) return undefined;
        let timeoutId;
        const onScroll = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                sessionStorage.setItem(INFO_REQUESTS_GRID_SCROLL_KEY, String(el.scrollTop));
            }, 120);
        };
        el.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            clearTimeout(timeoutId);
            el.removeEventListener('scroll', onScroll);
        };
    }, [loading]);

    useLayoutEffect(() => {
        if (loading) return undefined;
        if (sessionStorage.getItem(INFO_REQUESTS_RESTORE_SCROLL_PENDING_KEY) !== '1') {
            setGridHiddenForScrollRestore(false);
            return undefined;
        }
        const raw = sessionStorage.getItem(INFO_REQUESTS_GRID_SCROLL_KEY);
        if (raw == null || raw === '') {
            sessionStorage.removeItem(INFO_REQUESTS_RESTORE_SCROLL_PENDING_KEY);
            setGridHiddenForScrollRestore(false);
            return undefined;
        }
        const y = Number(raw);
        if (!Number.isFinite(y) || y < 0) {
            sessionStorage.removeItem(INFO_REQUESTS_RESTORE_SCROLL_PENDING_KEY);
            setGridHiddenForScrollRestore(false);
            return undefined;
        }

        const el = listScrollRef.current;
        if (!el) {
            sessionStorage.removeItem(INFO_REQUESTS_RESTORE_SCROLL_PENDING_KEY);
            setGridHiddenForScrollRestore(false);
            return undefined;
        }

        const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
        el.scrollTop = y;
        sessionStorage.removeItem(INFO_REQUESTS_RESTORE_SCROLL_PENDING_KEY);

        if (reducedMotion) {
            setGridHiddenForScrollRestore(false);
            return undefined;
        }

        requestAnimationFrame(() => {
            setGridHiddenForScrollRestore(false);
        });
        return undefined;
    }, [loading, filteredConnections.length]);

    function fetchDetailsAPI(userid) {
        setLoading(true);
        //console.log(this.state.userID)
        let formdata = new FormData();

        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")

        console.log(formdata);

        fetch(baseURL.URL + '/consumer_portfolio/free_estimate_request_msgs', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response.data
                console.log(responseJson.response.data)
                if (responseJson.server.result_code === 200) {
                    // 
                    //navigate('InfoDetails')
                    // DATA = result
                    setAllConnections(result)
                    setFilteredConnections(result)
                    setLoadData(true)
                    setLoading(false)

                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger');
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.error(error);
                setLoading(false)
            });
    }

    function normalizeDisplayValue(value) {
        if (value == null) return "";
        const normalized = String(value).trim();
        if (!normalized) return "";
        const lowered = normalized.toLowerCase();
        if (lowered === "null" || lowered === "undefined") return "";
        return normalized;
    }

    function handleSearchByName(event) {
        const value = event.target.value;
        setSearchText(value);
        const normalizedSearch = value.trim().toLowerCase();

        if (!normalizedSearch) {
            setFilteredConnections(allConnections);
            return;
        }

        const filtered = allConnections.filter((member) => {
            const firstName = normalizeDisplayValue(member?.consumer_details?.fname).toLowerCase();
            const lastName = normalizeDisplayValue(member?.consumer_details?.lname).toLowerCase();
            const fullName = `${firstName} ${lastName}`.trim();
            const displayName = normalizeDisplayValue(member?.name).toLowerCase();
            return fullName.includes(normalizedSearch) || displayName.includes(normalizedSearch);
        });

        setFilteredConnections(filtered);
    }

    function deleteButtonAPI(estimateType, estimateID) {

        let formdata = new FormData();

        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append('estimate_type', estimateType)
        formdata.append('estimate_id', estimateID)


        fetch(baseURL.URL + '/consumer_portfolio/delete_done_msgs', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.result_code === 200) {
                    showNotification('Success', responseJson.server.message, 'success');
                    fetchDetailsAPI(userID);
                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }


    function getCompletedListAPI() {
        setLoading(true);
        console.log(userID)
        let formdata = new FormData();

        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")



        fetch(baseURL.URL + '/consumer_portfolio/done_msgs', {
            method: 'POST',
            body: formdata

        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response.data
                console.log(result)
                if (responseJson.server.result_code === 200) {
                    // 
                    //navigate('InfoDetails')
                    // DATA = result
                    setAllConnections(result)
                    setFilteredConnections(result)
                    setLoadData(true)
                    setLoading(false)


                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger');
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.error(error);
                setLoading(false)
            });
    }

    function openDeleteConfirm(estimateType, estimateID) {
        setDeleteConfirmData({ estimateType, estimateID });
    }

    function closeDeleteConfirm() {
        setDeleteConfirmData(null);
    }

    function confirmDelete() {
        if (!deleteConfirmData) return;
        deleteButtonAPI(deleteConfirmData.estimateType, deleteConfirmData.estimateID);
        closeDeleteConfirm();
    }

    function handleIndexChange(index) {
        console.log('Index: ' + index)
        if (String(index) === "0") {
            console.log('Index0: ')
            fetchDetailsAPI(userID)

        } else if (String(index) === "1") {
            console.log('Index1: ')
            getCompletedListAPI()

        }
        setSelectedIndex(String(index))
    };
    function handleMemberCardClick(member) {
        persistInfoRequestsGridScrollForLeave();
        navigate('/portfolio-details', {
            state: {
                listingID: member?.listings?.listing_id,
                from: 'info-requests',
            }
        });
    }

    function navigateToConsumerProfileFromCard(member) {
        persistInfoRequestsGridScrollForLeave();
        navigate('/premium-home/consumer-profile', {
            state: {
                consumer_details: member?.consumer_details || {},
                premiumSidebarActive: "Info Requests",
            },
        });
    }

    function handlePremiumSidebarItemClick(item) {
        window.dispatchEvent(
            new CustomEvent("premiumMembersView", {
                detail: { isViewing: item === "Premium Members" },
            })
        );
        navigate("/premium-home", { state: { initialActiveItem: item } });
    }

    function handleMobileBackEmbedded() {
        navigate("/premium-home");
    }

    function handleMobileBackStandalone() {
        setIsMobilePageOpen(false);
    }

    const mobilePageHeader = (onBack) => (
        <div className="mobile-page-header">
            <button type="button" className="mobile-back-btn" onClick={onBack}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <path
                        d="M15 18L9 12L15 6"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                Back
            </button>
            <h2 className="mobile-page-title">{MOBILE_PAGE_TITLE}</h2>
        </div>
    );

    if (loading) {
        return (
            <div className="content-right page-loader-wrapper">
                <div className="react-js-loader">
                    <div className="react-js-loader-spinner"></div>
                    <p className="react-js-loader-text">Loading...</p>
                </div>
            </div>
        );
    }

    const infoRequestsInner = (
        <>
            {/* Search and Filter Section */}
            <div className="search-filter-section">
                <div className="search-bar">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        className="search-icon"
                    >
                        <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.5 17.5L13.875 13.875"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <input
                        type="text"
                        placeholder="Search by name / company"
                        className="search-input"
                        value={searchText}
                        onChange={handleSearchByName}
                    />
                </div>
                <button className="filter-btn">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16.4062 4.69678C14.5256 4.69678 12.9441 6.04475 12.5793 7.82178H2.34375C1.91228 7.82178 1.5625 8.17156 1.5625 8.60303C1.5625 9.0345 1.91228 9.38428 2.34375 9.38428H12.5793C12.9441 11.1613 14.5256 12.5093 16.4062 12.5093C18.2869 12.5093 19.8684 11.1613 20.2332 9.38428H22.6562C23.0877 9.38428 23.4375 9.0345 23.4375 8.60303C23.4375 8.17156 23.0877 7.82178 22.6562 7.82178H20.2332C19.8684 6.04475 18.2869 4.69678 16.4062 4.69678ZM16.4062 6.25928C17.7099 6.25928 18.75 7.29938 18.75 8.60303C18.75 9.90668 17.7099 10.9468 16.4062 10.9468C15.1026 10.9468 14.0625 9.90668 14.0625 8.60303C14.0625 7.29938 15.1026 6.25928 16.4062 6.25928Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.59375 12.5093C6.71313 12.5093 5.1316 13.8573 4.76685 15.6343H2.34375C1.91228 15.6343 1.5625 15.9841 1.5625 16.4155C1.5625 16.847 1.91228 17.1968 2.34375 17.1968H4.76685C5.1316 18.9738 6.71313 20.3218 8.59375 20.3218C10.4744 20.3218 12.0559 18.9738 12.4207 17.1968H22.6562C23.0877 17.1968 23.4375 16.847 23.4375 16.4155C23.4375 15.9841 23.0877 15.6343 22.6562 15.6343H12.4207C12.0559 13.8573 10.4744 12.5093 8.59375 12.5093ZM8.59375 14.0718C9.8974 14.0718 10.9375 15.1119 10.9375 16.4155C10.9375 17.7192 9.8974 18.7593 8.59375 18.7593C7.2901 18.7593 6.25 17.7192 6.25 16.4155C6.25 15.1119 7.2901 14.0718 8.59375 14.0718Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>
            <span className='listing-count'>{stringsoflanguages.noofmembers}: {filteredConnections.length}</span>
            {/* Member Cards Grid */}
            <div
                className={`member-cards-grid${gridHiddenForScrollRestore ? ' gm-grid--restore-hidden' : ''}`}
                ref={listScrollRef}
            >
                {filteredConnections.map((member) => {
                    const firstName = normalizeDisplayValue(member?.consumer_details?.fname);
                    const lastName = normalizeDisplayValue(member?.consumer_details?.lname);
                    const apiName = normalizeDisplayValue(member?.name);
                    const fullName = `${firstName} ${lastName}`.trim() || apiName || "N/A";
                    const requestDate = normalizeDisplayValue(member?.added_date);
                    const subject = normalizeDisplayValue(member?.subject) || "N/A";
                    const city = normalizeDisplayValue(member?.consumer_details?.city_name);
                    const country = normalizeDisplayValue(member?.consumer_details?.country_name);
                    const location = [city, country].filter(Boolean).join(" - ") || "N/A";
                    const email = normalizeDisplayValue(member?.consumer_details?.email);
                    const phone = normalizeDisplayValue(member?.consumer_details?.phone);
                    const favCount = normalizeDisplayValue(member?.consumer_details?.fav_count) || "0";
                    const imageUrl =
                        normalizeDisplayValue(member?.consumer_details?.picture) ||
                        profileAvatar;

                    return (
                        <div className="member-card" key={member?.estimate_id || fullName} style={{ position: "relative" }} onClick={() => handleMemberCardClick(member)}>
                            <div
                                className="fav-heart-badge"
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    zIndex: 2,
                                    color: "#ff4d6d",
                                    fontWeight: 600
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#ff4d6d" aria-hidden="true">
                                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                </svg>
                                <span>{favCount}</span>
                            </div>
                            <div className="member-info">
                                <p className="member-since">
                                    {requestDate ? `${stringsoflanguages.requestDate} ${requestDate}` : `${stringsoflanguages.requestDate} N/A`}
                                </p>
                                <h3 className="member-name">{fullName}</h3>
                                {/* <p className="member-role">{subject}</p> */}
                                <p className="member-location">{location}</p>

                                <div className="contact-section flex items-center gap-2">
                                    <Link to={phone ? `tel:${phone}` : "#"} className="contact-btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                        </svg>
                                    </Link>
                                    <Link to={email ? `mailto:${email}` : "#"} className="contact-btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                            <polyline points="22,6 12,13 2,6" />
                                        </svg>
                                    </Link>
                                    <Link to={phone ? `sms:${phone}` : "#"} className="contact-btn" aria-label="Message">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7323ff" strokeWidth="2">
                                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                        </svg>
                                    </Link>
                                </div>
                            </div>
                            <div
                                className="member-image"
                                role="presentation"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigateToConsumerProfileFromCard(member);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        navigateToConsumerProfileFromCard(member);
                                    }
                                }}
                            >
                                <img
                                    src={imageUrl}
                                    alt={fullName}
                                    role="button"
                                    tabIndex={0}
                                    style={{ cursor: "pointer" }}
                                />
                            </div>
                            <button
                                type="button"
                                aria-label="Remove"
                                onClick={() => openDeleteConfirm(member?.estimate_type, member?.estimate_id)}
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    bottom: "10px",
                                    width: "26px",
                                    height: "26px",
                                    borderRadius: "100%",
                                    background: "#ff4d6d",
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "12px",
                                    lineHeight: 1,
                                    cursor: "pointer"
                                }}
                            >
                                <i className="fa-regular fa-trash-can"></i>
                            </button>
                        </div>
                    );
                })}
            </div>
            {!isMobile && (
                <div className="btn-section btn-section-gear" ref={gearMenuRef}>
                    <button
                        type="button"
                        className={`btn-primary gear-btn ${gearSpinning ? 'gear-spin' : ''}`}
                        onClick={() => {
                            setGearMenuOpen((prev) => !prev);
                            setGearSpinning(true);
                            setTimeout(() => setGearSpinning(false), 500);
                        }}
                        aria-label="Options"
                        aria-expanded={gearMenuOpen}
                    >
                        <i className="fa-solid fa-gear"></i>
                    </button>
                    {gearMenuOpen && (
                        <ul className="gear-dropdown" aria-label="Options list">
                            <li>
                                <button
                                    type="button"
                                    className={`gear-dropdown-item${selectedIndex === "0" ? " active" : ""}`}
                                    onClick={() => { setGearMenuOpen(false); handleIndexChange("0"); }}
                                >
                                    <i className="fa-solid fa-circle-plus"></i>
                                    <span>{stringsoflanguages.list}</span>
                                </button>
                            </li>
                            <li>
                                <button
                                    type="button"
                                    className={`gear-dropdown-item${selectedIndex === "1" ? " active" : ""}`}
                                    onClick={() => { setGearMenuOpen(false); handleIndexChange("1"); }}
                                >
                                    <i className="fa-solid fa-circle-check"></i>
                                    <span>{stringsoflanguages.completedList}</span>
                                </button>
                            </li>
                        </ul>
                    )}
                </div>
            )}
            {isMobile && (
                <nav className="mobile-bottom-nav liquidGlass-wrapper dock info-requests-mobile-bottom-nav" aria-label="Info Requests actions">
                    <div className="liquidGlass-effect" aria-hidden="true" />
                    <div className="liquidGlass-shine" aria-hidden="true" />
                    <div className={`mobile-nav-item${selectedIndex === "0" ? " info-requests-mobile-nav-active" : ""}`} aria-label="List" aria-pressed={selectedIndex === "0"}
                        onClick={() => handleIndexChange("0")}>
                        <i className="fa-solid fa-circle-plus" aria-hidden="true" />
                    </div>
                    <div className={`mobile-nav-item${selectedIndex === "1" ? " info-requests-mobile-nav-active" : ""}`} aria-label="Completed List" aria-pressed={selectedIndex === "1"}
                        onClick={() => handleIndexChange("1")}>
                        <i className="fa-solid fa-circle-check" aria-hidden="true" />
                    </div>

                </nav>
            )}
            {deleteConfirmData && (
                <div className="modal-overlay" onClick={closeDeleteConfirm} aria-hidden="true">
                    <div
                        className="logout-modal"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="info-delete-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 id="info-delete-modal-title" className="text-white mb-4 text-center">Confirm Delete</h2>
                        <p className="text-center text-white mb-4">
                            Are you sure you want to delete this request?
                        </p>
                        <div className="btn-sec">
                            <button type="button" className="cancel-btn" onClick={closeDeleteConfirm}>
                                No
                            </button>
                            <button type="button" className="save-btn" onClick={confirmDelete}>
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <svg style={{ display: 'none' }} aria-hidden="true">
                <filter id="glass-distortion" x="0%" y="0%" width="100%" height="100%" filterUnits="objectBoundingBox">
                    <feTurbulence type="fractalNoise" baseFrequency="0.01 0.01" numOctaves="1" seed="5" result="turbulence" />
                    <feComponentTransfer in="turbulence" result="mapped">
                        <feFuncR type="gamma" amplitude="1" exponent="10" offset="0.5" />
                        <feFuncG type="gamma" amplitude="0" exponent="1" offset="0" />
                        <feFuncB type="gamma" amplitude="0" exponent="1" offset="0.5" />
                    </feComponentTransfer>
                    <feGaussianBlur in="turbulence" stdDeviation="3" result="softMap" />
                    <feSpecularLighting in="softMap" surfaceScale="5" specularConstant="1" specularExponent="100" lightingColor="white" result="specLight">
                        <fePointLight x="-200" y="-200" z="300" />
                    </feSpecularLighting>
                    <feComposite in="specLight" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="litImage" />
                    <feDisplacementMap in="SourceGraphic" in2="softMap" scale="150" xChannelSelector="R" yChannelSelector="G" />
                </filter>
            </svg>
        </>
    );

    if (isEmbeddedInPremiumHome) {
        return (
            <>
                {isMobile && mobilePageHeader(handleMobileBackEmbedded)}
                <div className="content-right info-requests-page listing-active-page">{infoRequestsInner}</div>
            </>
        );
    }

    return (
        <>
            <section className="home">
                <div className="container">
                    <div className="content-holder">
                        <PremiumSidebar
                            activeItem={MOBILE_PAGE_TITLE}
                            setActiveItem={handlePremiumSidebarItemClick}
                        />
                        <div
                            className={`content-right-wrapper ${isMobilePageOpen ? "mobile-page-open" : ""}`}
                        >
                            {isMobile && isMobilePageOpen && mobilePageHeader(handleMobileBackStandalone)}
                            <div className="content-right info-requests-page completed-list-page">{infoRequestsInner}</div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}